'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _taggedTemplateLiteral2 = require('babel-runtime/helpers/taggedTemplateLiteral');

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  background-color: #ffffff;\n  border-color: #e5e5e5;\n  border-bottom-width: 1px;\n  border-bottom-style: solid;\n  font-family: \'Nunito Sans\', \'Helvetica Neue\', HelveticaNeue, Helvetica, Arial,\n    sans-serif;\n'], ['\n  background-color: #ffffff;\n  border-color: #e5e5e5;\n  border-bottom-width: 1px;\n  border-bottom-style: solid;\n  font-family: \'Nunito Sans\', \'Helvetica Neue\', HelveticaNeue, Helvetica, Arial,\n    sans-serif;\n']),
    _templateObject2 = (0, _taggedTemplateLiteral3.default)(['\n  height: 80px;\n  overflow: initial;\n  padding-left: 24px;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: flex-start;\n  max-width: 1272px;\n  box-sizing: border-box;\n  margin: ', ';\n  ', '\n'], ['\n  height: 80px;\n  overflow: initial;\n  padding-left: 24px;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: flex-start;\n  max-width: 1272px;\n  box-sizing: border-box;\n  margin: ', ';\n  ', '\n']),
    _templateObject3 = (0, _taggedTemplateLiteral3.default)(['\n    padding-left: 16px;\n    overflow: hidden;\n  '], ['\n    padding-left: 16px;\n    overflow: hidden;\n  ']),
    _templateObject4 = (0, _taggedTemplateLiteral3.default)(['\n  display: flex;\n  align-items: center;\n  margin-right: 32px;\n  flex-direction: column;\n  ', '\n  ', '\n  ', '\n  ', '\n  ', '\n  ', '\n  ', '\n  ', '\n'], ['\n  display: flex;\n  align-items: center;\n  margin-right: 32px;\n  flex-direction: column;\n  ', '\n  ', '\n  ', '\n  ', '\n  ', '\n  ', '\n  ', '\n  ', '\n']),
    _templateObject5 = (0, _taggedTemplateLiteral3.default)(['margin-right: 0;'], ['margin-right: 0;']),
    _templateObject6 = (0, _taggedTemplateLiteral3.default)(['margin-right: 16px;'], ['margin-right: 16px;']),
    _templateObject7 = (0, _taggedTemplateLiteral3.default)(['margin-right: 32px;'], ['margin-right: 32px;']),
    _templateObject8 = (0, _taggedTemplateLiteral3.default)(['margin-right: 0px;'], ['margin-right: 0px;']),
    _templateObject9 = (0, _taggedTemplateLiteral3.default)(['\n  display: flex;\n  align-items: center;\n'], ['\n  display: flex;\n  align-items: center;\n']),
    _templateObject10 = (0, _taggedTemplateLiteral3.default)(['\n  margin-left: 16px;\n  display: flex;\n'], ['\n  margin-left: 16px;\n  display: flex;\n']),
    _templateObject11 = (0, _taggedTemplateLiteral3.default)(['\n  ', ';\n  margin-left: 32px;\n  font-weight: 600;\n  text-align: center;\n  text-decoration: none;\n  color: #4a4a4a;\n  &:hover {\n    color: #6e0ad6;\n  }\n\n  ', '\n'], ['\n  ', ';\n  margin-left: 32px;\n  font-weight: 600;\n  text-align: center;\n  text-decoration: none;\n  color: #4a4a4a;\n  &:hover {\n    color: #6e0ad6;\n  }\n\n  ', '\n']),
    _templateObject12 = (0, _taggedTemplateLiteral3.default)(['margin-left: 24px;'], ['margin-left: 24px;']),
    _templateObject13 = (0, _taggedTemplateLiteral3.default)(['\n  ', '\n  ', '\n  ', '\n  ', '\n  ', '\n'], ['\n  ', '\n  ', '\n  ', '\n  ', '\n  ', '\n']),
    _templateObject14 = (0, _taggedTemplateLiteral3.default)(['display: none;'], ['display: none;']),
    _templateObject15 = (0, _taggedTemplateLiteral3.default)(['display: block;'], ['display: block;']),
    _templateObject16 = (0, _taggedTemplateLiteral3.default)(['\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-start;\n  flex: 1;\n  ', '\n  ', '\n'], ['\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-start;\n  flex: 1;\n  ', '\n  ', '\n']),
    _templateObject17 = (0, _taggedTemplateLiteral3.default)(['\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-end;\n  align-items: center;\n  flex: 1;\n'], ['\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-end;\n  align-items: center;\n  flex: 1;\n']),
    _templateObject18 = (0, _taggedTemplateLiteral3.default)(['\n  ', '\n  ', '\n  ', '\n'], ['\n  ', '\n  ', '\n  ', '\n']),
    _templateObject19 = (0, _taggedTemplateLiteral3.default)(['\n    & > :not(span) {\n      display: none;\n    }\n  '], ['\n    & > :not(span) {\n      display: none;\n    }\n  ']),
    _templateObject20 = (0, _taggedTemplateLiteral3.default)(['\n    display: ', ';\n    & > :not(span) {\n      display: initial;\n    }\n  '], ['\n    display: ', ';\n    & > :not(span) {\n      display: initial;\n    }\n  ']),
    _templateObject21 = (0, _taggedTemplateLiteral3.default)(['\n    & > span {\n      display: none;\n    }\n    & > :not(span) {\n      display: initial;\n    }\n  '], ['\n    & > span {\n      display: none;\n    }\n    & > :not(span) {\n      display: initial;\n    }\n  ']),
    _templateObject22 = (0, _taggedTemplateLiteral3.default)(['\n  line-height: 19px;\n  position: absolute;\n  top: -8px;\n  left: -6px;\n  margin: 0px;\n  font-weight: 700;\n  font-size: 10px;\n  text-align: center;\n  border-radius: 50%;\n  background-color: rgb(247,131,35);\n  z-index: 100;\n  width: 17px;\n  height: 17px;\n  color: white;\n  @-moz-document url-prefix() { line-height: 17px }\n  ', '\n'], ['\n  line-height: 19px;\n  position: absolute;\n  top: -8px;\n  left: -6px;\n  margin: 0px;\n  font-weight: 700;\n  font-size: 10px;\n  text-align: center;\n  border-radius: 50%;\n  background-color: rgb(247,131,35);\n  z-index: 100;\n  width: 17px;\n  height: 17px;\n  color: white;\n  @-moz-document url-prefix() { line-height: 17px }\n  ', '\n']),
    _templateObject23 = (0, _taggedTemplateLiteral3.default)(['\n  ', '\n  ', '\n  ', '\n  & > li {\n    display: ', ';\n  }\n'], ['\n  ', '\n  ', '\n  ', '\n  & > li {\n    display: ', ';\n  }\n']),
    _templateObject24 = (0, _taggedTemplateLiteral3.default)(['\n    display: flex;\n    & > :not(span) {\n      display: initial;\n    }\n  '], ['\n    display: flex;\n    & > :not(span) {\n      display: initial;\n    }\n  ']),
    _templateObject25 = (0, _taggedTemplateLiteral3.default)(['\n  ', '\n  ', '\n'], ['\n  ', '\n  ', '\n']),
    _templateObject26 = (0, _taggedTemplateLiteral3.default)(['\n    & > :not(span) {\n      display:none;\n    }\n  '], ['\n    & > :not(span) {\n      display:none;\n    }\n  ']),
    _templateObject27 = (0, _taggedTemplateLiteral3.default)(['\n  ', '\n  ', '\n  @media (max-width: 55em) {\n    display: none;\n  }\n'], ['\n  ', '\n  ', '\n  @media (max-width: 55em) {\n    display: none;\n  }\n']),
    _templateObject28 = (0, _taggedTemplateLiteral3.default)(['\n  margin-left: 24px;\n  margin-right: 24px;\n  ', '\n  ', '\n  ', '\n  ', '\n  ', '\n  ', '\n'], ['\n  margin-left: 24px;\n  margin-right: 24px;\n  ', '\n  ', '\n  ', '\n  ', '\n  ', '\n  ', '\n']),
    _templateObject29 = (0, _taggedTemplateLiteral3.default)(['margin-left: 32px;'], ['margin-left: 32px;']),
    _templateObject30 = (0, _taggedTemplateLiteral3.default)(['margin-left: 16px;'], ['margin-left: 16px;']),
    _templateObject31 = (0, _taggedTemplateLiteral3.default)(['margin-left: 12px;'], ['margin-left: 12px;']),
    _templateObject32 = (0, _taggedTemplateLiteral3.default)(['\n  display: none;\n  margin-right: 16px;\n  position: relative;\n  ', '\n\n  ', '\n'], ['\n  display: none;\n  margin-right: 16px;\n  position: relative;\n  ', '\n\n  ', '\n']),
    _templateObject33 = (0, _taggedTemplateLiteral3.default)(['display: inherit;'], ['display: inherit;']),
    _templateObject34 = (0, _taggedTemplateLiteral3.default)(['\n      &:after {\n        content: \'\';\n        position: absolute;\n        right: 0px;\n        top: 0px;\n        background: #f78323;\n        width: 12px;\n        height: 12px;\n        border-radius: 100%;\n        pointer-events: none;\n      }\n    '], ['\n      &:after {\n        content: \'\';\n        position: absolute;\n        right: 0px;\n        top: 0px;\n        background: #f78323;\n        width: 12px;\n        height: 12px;\n        border-radius: 100%;\n        pointer-events: none;\n      }\n    ']),
    _templateObject35 = (0, _taggedTemplateLiteral3.default)(['\n  z-index: 1000;\n  visibility: hidden;\n  background-color: rgba(0, 0, 0, 0);\n  transition: visibility 300ms ease, background 300ms ease;\n  width: 100%;\n  height: 100%;\n  position: absolute;\n\n  &.visible {\n    ', ';\n  }\n'], ['\n  z-index: 1000;\n  visibility: hidden;\n  background-color: rgba(0, 0, 0, 0);\n  transition: visibility 300ms ease, background 300ms ease;\n  width: 100%;\n  height: 100%;\n  position: absolute;\n\n  &.visible {\n    ', ';\n  }\n']),
    _templateObject36 = (0, _taggedTemplateLiteral3.default)(['\n      visibility: visible;\n      background-color: rgba(0,0,0,0.55);\n    '], ['\n      visibility: visible;\n      background-color: rgba(0,0,0,0.55);\n    ']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _propTypes = require('prop-types');

var _bodyScrollLock = require('body-scroll-lock');

var _CustomLinkBox = require('./CustomLinkBox');

var _CustomLinkBox2 = _interopRequireDefault(_CustomLinkBox);

var _MyHeaderSubMenu = require('./MyHeaderSubMenu');

var _MinhaContaLink = require('./MinhaContaLink');

var _Hamburger = require('../../atoms/Hamburger');

var _Hamburger2 = _interopRequireDefault(_Hamburger);

var _LinkButton = require('../../atoms/LinkButton');

var _LinkButton2 = _interopRequireDefault(_LinkButton);

var _Logo = require('../../fundamentals/Logo');

var _Logo2 = _interopRequireDefault(_Logo);

var _Icon = require('../../atoms/Icon');

var _Icon2 = _interopRequireDefault(_Icon);

var _chat = require('../../../assets/icons/chat');

var _chat2 = _interopRequireDefault(_chat);

var _grid = require('../../../assets/icons/grid');

var _grid2 = _interopRequireDefault(_grid);

var _central = require('../../../assets/icons/central');

var _central2 = _interopRequireDefault(_central);

var _briefcase = require('../../../assets/icons/briefcase');

var _briefcase2 = _interopRequireDefault(_briefcase);

var _medias = require('../../../util/medias');

var _medias2 = _interopRequireDefault(_medias);

var _font = require('../../../util/font');

var _lurker = require('../../../util/lurker');

var _staticUrl = require('../../../config/staticUrl');

var _myAccountDataApiCall = require('../../../api/myAccountDataApiCall');

var _myAccountDataApiCall2 = _interopRequireDefault(_myAccountDataApiCall);

var _notificationDataApiCall = require('../../../api/notificationDataApiCall');

var _notificationDataApiCall2 = _interopRequireDefault(_notificationDataApiCall);

var _abTests = require('../../../config/abTests');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Content = _styledComponents2.default.div(_templateObject);

var HeaderWrapper = _styledComponents2.default.header(_templateObject2, function () {
  return 'auto';
}, _medias2.default.medium(_templateObject3));

var LogBox = _styledComponents2.default.div(_templateObject4, _medias2.default.large(_templateObject5), function (props) {
  return props.isCentralMenuEnabled && _medias2.default.extraLarge(_templateObject6);
}, function (props) {
  return props.hasSearchInput && _medias2.default.extraLarge(_templateObject7);
}, function (props) {
  return props.isCentralMenuEnabled && _medias2.default.large(_templateObject6);
}, function (props) {
  return props.hasSearchInput && _medias2.default.large(_templateObject7);
}, function (props) {
  return props.isCentralMenuEnabled && _medias2.default.medium(_templateObject8);
}, function (props) {
  return props.isCentralMenuEnabled && _medias2.default.small(_templateObject8);
}, function (props) {
  return props.isCentralMenuEnabled && _medias2.default.tiny(_templateObject8);
});

var LogosContainer = _styledComponents2.default.div(_templateObject9);

var SubProduct = _styledComponents2.default.div(_templateObject10);

var LinkMenu = _styledComponents2.default.a(_templateObject11, _font.fontSemiSmall, function (props) {
  return props.isCentralMenuEnabled && _medias2.default.large(_templateObject12);
});

var LinkMenuDesktop = (0, _styledComponents2.default)(LinkMenu)(_templateObject13, function (props) {
  return props.hasSearchInput ? 'display: none;' : _medias2.default.small(_templateObject14);
}, function (props) {
  return props.isCentralMenuEnabled && _medias2.default.extraLarge(_templateObject12);
}, function (props) {
  return props.isCentralMenuEnabled && _medias2.default.large(_templateObject12);
}, function (props) {
  return props.isCentralMenuEnabled && _medias2.default.medium(_templateObject12);
}, function (props) {
  return props.hasSearchInput && _medias2.default.medium(_templateObject15);
});

var SearchInputDesktop = _styledComponents2.default.div(_templateObject16, _medias2.default.medium(_templateObject14), _medias2.default.small(_templateObject14));

var RightBox = _styledComponents2.default.div(_templateObject17);

var LinkBoxOfChat = (0, _styledComponents2.default)(_CustomLinkBox2.default)(_templateObject18, _medias2.default.large(_templateObject19), function (props) {
  return _medias2.default.medium(_templateObject20, props.isLogged ? 'flex' : 'none');
}, function (props) {
  return props.isLogged && _medias2.default.small(_templateObject21);
});

var Badge = _styledComponents2.default.li(_templateObject22, function (props) {
  return props.multipleChars && 'padding-left: 1px';
});

var LinkBoxOfCentral = (0, _styledComponents2.default)(_CustomLinkBox2.default)(_templateObject23, _medias2.default.large(_templateObject19), _medias2.default.medium(_templateObject24), _medias2.default.small(_templateObject21), function (props) {
  return props.hasCounterBadge ? 'block' : 'none';
});

var LinkBoxOfMyAds = (0, _styledComponents2.default)(_CustomLinkBox2.default)(_templateObject25, _medias2.default.large(_templateObject26), _medias2.default.medium(_templateObject14));

var LinkBoxOfMyPlan = (0, _styledComponents2.default)(_CustomLinkBox2.default)(_templateObject27, function (_ref) {
  var showMyPlanButton = _ref.showMyPlanButton;
  return showMyPlanButton ? '' : 'display: none';
}, _medias2.default.large(_templateObject26));

var AnunciarBox = _styledComponents2.default.div(_templateObject28, _medias2.default.large(_templateObject29), _medias2.default.medium(_templateObject6), _medias2.default.tiny(_templateObject30), function (props) {
  return props.isCentralMenuEnabled && _medias2.default.large(_templateObject12);
}, function (props) {
  return props.isCentralMenuEnabled && _medias2.default.small(_templateObject30);
}, function (props) {
  return props.isCentralMenuEnabled && _medias2.default.tiny(_templateObject31);
});

var MenuIcon = (0, _styledComponents2.default)(_Hamburger2.default)(_templateObject32, _medias2.default.medium(_templateObject33), function (props) {
  return props.hasBadge && (0, _styledComponents.css)(_templateObject34);
});

var HeaderSubMenuMobileWrapper = _styledComponents2.default.div(_templateObject35, _medias2.default.medium(_templateObject36));

var Header = function (_React$PureComponent) {
  (0, _inherits3.default)(Header, _React$PureComponent);

  function Header(props) {
    (0, _classCallCheck3.default)(this, Header);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Header.__proto__ || (0, _getPrototypeOf2.default)(Header)).call(this, props));

    _this.state = {
      loading: true,
      showSubMenu: false,
      userName: null,
      profilePictureUrl: null,
      isLogged: null,
      notifications: 0,
      publicAccountId: null,
      hasBadge: false,
      urls: {}
    };

    _this.toggleSubMenu = _this.toggleSubMenu.bind(_this);
    _this.handleSubMenuMobileClick = _this.handleSubMenuMobileClick.bind(_this);
    _this.subMenuRef = _react2.default.createRef();
    return _this;
  }

  (0, _createClass3.default)(Header, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.loadAccountData();
      this.setState({
        urls: (0, _extends3.default)({}, (0, _staticUrl.getUrls)())
      });
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      (0, _bodyScrollLock.clearAllBodyScrollLocks)();
    }
  }, {
    key: 'loadAccountData',
    value: function loadAccountData() {
      var _this2 = this;

      (0, _myAccountDataApiCall2.default)().then(function (accountData) {
        var facebookPictureUrl = accountData.facebookPictureUrl,
            googlePictureUrl = accountData.googlePictureUrl;


        var profilePictureUrl = void 0;
        if (facebookPictureUrl) {
          profilePictureUrl = facebookPictureUrl;
        } else if (googlePictureUrl) {
          profilePictureUrl = googlePictureUrl;
        }

        var maxUserNameLen = 16;
        var userName = accountData.nickname;
        if (userName.length > maxUserNameLen) {
          userName = userName.substring(0, maxUserNameLen - 1) + '\u2026';
        }

        _this2.setState({
          loading: false,
          isLogged: true,
          publicAccountId: accountData.publicAccountId,
          userName: userName,
          profilePictureUrl: profilePictureUrl
        });

        _this2.loadNotificationData();
      }).catch(function () {
        _this2.setState({
          isLogged: false,
          loading: false
        });
      });
    }
  }, {
    key: 'loadNotificationData',
    value: function loadNotificationData() {
      var _this3 = this;

      (0, _notificationDataApiCall2.default)().then(function (notifications) {
        _this3.setState({
          notifications: notifications,
          hasBadge: !(0, _abTests.isCentralHeaderMenuEnabled)() && notifications > 0
        });
      }).catch(function () {
        _this3.setState({
          notifications: 0,
          hasBadge: false
        });
      });
    }
  }, {
    key: 'toggleSubMenu',
    value: function toggleSubMenu() {
      var _this4 = this;

      this.setState(function (prevState) {
        return { showSubMenu: !prevState.showSubMenu };
      }, function () {
        return _this4.state.showSubMenu ? (0, _bodyScrollLock.disableBodyScroll)(_this4.subMenuRef.current) : (0, _bodyScrollLock.enableBodyScroll)(_this4.subMenuRef.current);
      });
    }

    // eslint-disable-next-line

  }, {
    key: 'handleSubMenuMobileClick',
    value: function handleSubMenuMobileClick(e) {
      e.stopPropagation();
    }
  }, {
    key: 'render',
    value: function render() {
      var _state = this.state,
          showSubMenu = _state.showSubMenu,
          loading = _state.loading,
          notifications = _state.notifications,
          isLogged = _state.isLogged,
          hasBadge = _state.hasBadge,
          userName = _state.userName,
          profilePictureUrl = _state.profilePictureUrl,
          publicAccountId = _state.publicAccountId,
          _state$urls = _state.urls,
          home = _state$urls.home,
          busca = _state$urls.busca,
          meusAnuncios = _state$urls.meusAnuncios,
          chat = _state$urls.chat,
          inserirAnuncio = _state$urls.inserirAnuncio,
          central = _state$urls.central;

      var userProfileLink = 'https://www.olx.com.br/perfil/' + publicAccountId;

      var _props = this.props,
          showMyPlanButton = _props.showMyPlanButton,
          productLogo = _props.productLogo,
          searchInput = _props.searchInput,
          showSearchButton = _props.showSearchButton;


      var accountLink = void 0;
      if (isLogged === true) {
        accountLink = _react2.default.createElement(_MinhaContaLink.MinhaContaLinkLogged, {
          userName: userName,
          profilePictureUrl: profilePictureUrl,
          notifications: notifications,
          hasBadge: hasBadge,
          userProfileLink: userProfileLink
        });
      } else if (isLogged === false) accountLink = _react2.default.createElement(_MinhaContaLink.MinhaContaLinkUnlogged, null);else accountLink = _react2.default.createElement(_MinhaContaLink.MinhaContaLinkDefault, null);

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          Content,
          { xsValign: 'middle' },
          _react2.default.createElement(
            HeaderWrapper,
            null,
            _react2.default.createElement(MenuIcon, {
              onClick: this.toggleSubMenu,
              hasBadge: hasBadge
            }),
            _react2.default.createElement(
              LogBox,
              {
                hasSearchInput: !!searchInput,
                isCentralMenuEnabled: (0, _abTests.isCentralHeaderMenuEnabled)()
              },
              _react2.default.createElement(
                LogosContainer,
                null,
                _react2.default.createElement(_Logo2.default, { href: home, onClick: function onClick() {
                    return (0, _lurker.lurkerClickEvt)('logo');
                  } }),
                productLogo && _react2.default.createElement(
                  SubProduct,
                  null,
                  productLogo
                )
              )
            ),
            showSearchButton && _react2.default.createElement(
              LinkMenuDesktop,
              {
                href: busca,
                onClick: function onClick() {
                  return (0, _lurker.lurkerClickEvt)('header_buscar');
                },
                isCentralMenuEnabled: (0, _abTests.isCentralHeaderMenuEnabled)(),
                hasSearchInput: !!searchInput
              },
              'Buscar'
            ),
            !loading && searchInput && _react2.default.createElement(
              SearchInputDesktop,
              null,
              searchInput
            ),
            !loading && _react2.default.createElement(
              RightBox,
              null,
              _react2.default.createElement(
                LinkBoxOfMyPlan,
                {
                  url: _staticUrl.meuPlano,
                  innerRender: 'Plano Profissional',
                  showMyPlanButton: showMyPlanButton,
                  onClick: function onClick() {
                    return (0, _lurker.lurkerClickEvent)('myplan', 'navbar');
                  }
                },
                _react2.default.createElement(_Icon2.default, { width: 24, height: 24, svgPath: _briefcase2.default })
              ),
              _react2.default.createElement(
                LinkBoxOfMyAds,
                { url: meusAnuncios, innerRender: 'Meus An\xFAncios' },
                _react2.default.createElement(_Icon2.default, { width: 24, height: 24, svgPath: _grid2.default })
              ),
              _react2.default.createElement(
                LinkBoxOfChat,
                { url: chat, innerRender: 'Chat', isLogged: isLogged },
                _react2.default.createElement(_Icon2.default, { width: 24, height: 24, svgPath: _chat2.default })
              ),
              (0, _abTests.isCentralHeaderMenuEnabled)() && _react2.default.createElement(
                LinkBoxOfCentral,
                {
                  url: central,
                  innerRender: 'Notifica\xE7\xF5es',
                  hasCounterBadge: notifications > 0 && isLogged,
                  onClick: function onClick() {
                    return (0, _lurker.lurkerClickEvent)('bell_header', 'notification', { data: { has_badge: notifications > 0 ? 'true' : 'false' } });
                  }
                },
                _react2.default.createElement(
                  Badge,
                  { multipleChars: notifications > 9 },
                  notifications > 9 ? '9+' : notifications
                ),
                _react2.default.createElement(_Icon2.default, { width: 24, height: 24, svgPath: _central2.default })
              ),
              accountLink,
              _react2.default.createElement(
                AnunciarBox,
                { isCentralMenuEnabled: (0, _abTests.isCentralHeaderMenuEnabled)() },
                _react2.default.createElement(_LinkButton2.default, {
                  href: inserirAnuncio,
                  track: 'ad_insertion',
                  text: (0, _abTests.isGratuityPerceptionEnabled)() ? 'Anunciar Grátis' : 'Anunciar',
                  width: '120px',
                  height: '40px'
                })
              )
            )
          )
        ),
        _react2.default.createElement(
          HeaderSubMenuMobileWrapper,
          {
            className: showSubMenu ? 'visible' : null,
            onClick: this.toggleSubMenu
          },
          _react2.default.createElement(_MyHeaderSubMenu.HeaderSubMenuMobile, {
            isOpen: showSubMenu,
            isLogged: isLogged,
            userName: userName,
            profilePictureUrl: profilePictureUrl,
            notifications: notifications,
            userProfileLink: userProfileLink,
            showMyPlanButton: showMyPlanButton,
            onClick: this.handleSubMenuMobileClick,
            ref: this.subMenuRef
          })
        )
      );
    }
  }]);
  return Header;
}(_react2.default.PureComponent);

Header.propTypes = {
  showMyPlanButton: _propTypes.bool,
  productLogo: (0, _propTypes.oneOfType)([_propTypes.element, _propTypes.object, _propTypes.string]),
  searchInput: _propTypes.node,
  showSearchButton: _propTypes.bool
};

Header.defaultProps = {
  showMyPlanButton: false,
  showSearchButton: true
};

exports.default = Header;